import { render, staticRenderFns } from "./TissAssinaturas.vue?vue&type=template&id=43e4be1a&"
import script from "./TissAssinaturas.vue?vue&type=script&lang=js&"
export * from "./TissAssinaturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports